import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { formatarPreco as formatarPrecoUtil } from '../../utils/cardapio-preco.util';

@Component({
  selector: 'app-cardapio-carrinho-footer',
  templateUrl: './cardapio-carrinho-footer.component.html',
  styleUrls: ['./cardapio-carrinho-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardapioCarrinhoFooterComponent {
  @Input() quantidade = 0;
  @Input() total = 0;
  @Input() fundo = '#007BFF';
  @Input() texto = '#FFFFFF';
  @Input() moedaSimbolo = 'BRL';
  @Input() moedaLocal = 'pt-BR';
  @Output() verPedido = new EventEmitter<void>();
  @Output() limparCarrinho = new EventEmitter<void>();

  formatarPreco(valor: number): string {
    return formatarPrecoUtil(valor, this.moedaSimbolo, this.moedaLocal);
  }
}
